import React, {TextareaHTMLAttributes, useRef} from "react";

const FormDislikedFeedback = (props: any) => {
    const {submitForm, setShowDislikedFeedback, setActiveDislikedUi, setTimeOutMessage} = props;
    const notHelpfulFeedback = [
        "irrelevant",
        "inaccurate",
        "outdated",
        "other"
    ];
    const formNotHelpful = useRef<HTMLFormElement | null>(null);
    const handleSubmitFeedback = (e: any) => {
        e.preventDefault();
        const formData = new FormData(formNotHelpful.current!);
        const data = Object.fromEntries(formData.entries());
        if (data.feedbackOption !== "other") {
            data.otherFeedback = "";
        }
        if (validateFormNotHelpful(true, data)) {
            let hideMessage = setTimeout(() => {
                setShowDislikedFeedback(false);
                clearTimeout(hideMessage);
            }, 5000);
            setActiveDislikedUi(true);
            setTimeOutMessage(hideMessage);
            submitForm({helpful: false, ...data});
        }

    }

    const validateFormNotHelpful = (submitForm: boolean, data: any) => {
        if (formNotHelpful.current) {

            let otherFeedback = document.querySelector(".other-radio");
            let otherFeedbackText = document.querySelector(".other-feedback-text");
            otherFeedback!.classList.remove("error");
            otherFeedbackText!.classList.remove("error");
            if (!data.feedbackOption) {
                otherFeedback!.classList.add("error");
                return false;
            }
            if (submitForm && data.feedbackOption === "other") {
                if (data.otherFeedback === "") {
                    otherFeedbackText!.classList.add("error");
                    return false;
                }
                if (!validateLengthOtherFeedbackText(data.otherFeedback)) {
                    return false;
                }

            }
            return true;
        }
    }
    const handleOtherFeedback = (e: any) => {
        if (formNotHelpful.current) {
            const formData = new FormData(formNotHelpful.current!);
            const data = Object.fromEntries(formData.entries());
            if (data.feedbackOption !== "other") {
                data.otherFeedback = "";
            }
            validateFormNotHelpful(false, data);
            let otherFeedback = formNotHelpful.current![4] as TextareaHTMLAttributes<any>;
            document.querySelector(".other-feedback-text")?.classList.toggle("show", e.currentTarget.value === "other");
        }
    }
    const validateLengthOtherFeedbackText = (textValue: any) => {
        let messageElm = document.querySelector(".message-max-length");
        let countText = textValue.length - 200;
        if (countText > 0) {
            messageElm!.textContent = "Cannot exceed 200 characters -" + countText;
            return false;
        } else {
            messageElm!.textContent = "";
            return true;
        }
    }


    return (
        <div className="dislike-feedback" id="dislike-feedback">
            <form className="feedback-form" onSubmit={handleSubmitFeedback} ref={formNotHelpful}>
                <div className="feedback-title">Tell us why the generated answer wasn’t helpful
                </div>
                {notHelpfulFeedback.map((item, index) => {
                    return (
                        <div className={"feedback-radio" + (item === "other" ? " other-radio" : "")} key={index}>
                            <input type="radio" onChange={handleOtherFeedback} name="feedbackOption"
                                   value={item} id={"feedback-" + index}/>
                            {item === "other" && (<span className="message required-error">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 512 512"><path d="M228.9 79.9L51.8 403.1C40.6 423.3 55.5 448 78.9 448h354.3c23.3 0 38.2-24.7 27.1-44.9L283.1 79.9c-11.7-21.2-42.5-21.2-54.2 0zM273.6 214L270 336h-28l-3.6-122h35.2zM256 402.4c-10.7 0-19.1-8.1-19.1-18.4s8.4-18.4 19.1-18.4 19.1 8.1 19.1 18.4-8.4 18.4-19.1 18.4z" fill="#CB7410"/></svg>
                                Please fill out this field</span>)}
                            <label className="feedback-label"
                                   htmlFor={"feedback-" + index}>{item.toLowerCase()}</label>
                        </div>
                    );
                })}
                <div className="other-feedback other-feedback-text">
                    <textarea className="other-feedback-input" onChange={(e) => validateLengthOtherFeedbackText(e.target.value)} name="otherFeedback"
                              placeholder="Please leave your comment"></textarea>
                    <span className="message-max-length"></span>
                    <span className="message required-error">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 512 512"><path d="M228.9 79.9L51.8 403.1C40.6 423.3 55.5 448 78.9 448h354.3c23.3 0 38.2-24.7 27.1-44.9L283.1 79.9c-11.7-21.2-42.5-21.2-54.2 0zM273.6 214L270 336h-28l-3.6-122h35.2zM256 402.4c-10.7 0-19.1-8.1-19.1-18.4s8.4-18.4 19.1-18.4 19.1 8.1 19.1 18.4-8.4 18.4-19.1 18.4z" fill="#CB7410"/></svg>
                                Please fill out this field</span>
                </div>
                <button className="submit-feedback" type="submit">submit</button>
            </form>
        </div>
    );
}

export default FormDislikedFeedback